<template>
  <div class="project-user-list page-box">
    <div class="page-content">
      <div class="content-header">
        <div class="m-input-outer">
          <el-input
            class="search-input box-item"
            v-model="nickname"
            placeholder="好友昵称"
            style="width: 100%"
            clearable
          ></el-input>
        </div>
        <el-input
          class="search-input box-item hidden-xs-only"
          v-model="nickname"
          placeholder="好友昵称"
          clearable
        ></el-input>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('wx:bot:client:friend:sync')"
          class="add-btn btn box-item"
          @click="syncHandle"
        >同步好友</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              微信id
            </vs-th>
            <vs-th>
              昵称
            </vs-th>
            <vs-th>
              TAG
            </vs-th>
            <vs-th>
              备注
            </vs-th>
            <vs-th>
              创建时间
            </vs-th>
            <vs-th>
              更新时间
            </vs-th>
<!--            <vs-th>
              操作
            </vs-th>-->
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.wxId || '-'}}
              </vs-td>
              <vs-td>
                {{tr.nickname}}
              </vs-td>
              <vs-td>
                {{tr.wxTagNames}}
              </vs-td>
              <vs-td>
                {{tr.remark}}
              </vs-td>
              <vs-td>
                {{parseTime(tr.createTime)}}
              </vs-td>
              <vs-td>
                {{parseTime(tr.updateTime)}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import { syncFriend } from "@/api/wechat/wechatPanel";
export default {
  name: "friendList",
  components: {
  },
  props: {
    botId: {
      type: Number,
      default: 0
    },
    activeName:{}
  },
  data() {
    return {
      nickname: '',

      red: '#D85E5F',
      green: '#41B883',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  watch:{
    botId(newVal,oldVal){
      if(newVal){
        this.searchHandle();
      }
    },
    activeName(newVal,oldVal){
      this.searchHandle();
    },
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/wxBotClientFriend/list';
      this.params = {
        page: this.page,
        limit: this.size,
      }
      if(this.botId){
        this.params.botId = this.botId;
      }
      if(this.nickname){
        this.params.nickname = this.nickname;
      }
      return true;
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    syncHandle(){
      this.$vs.loading();
      syncFriend(this.botId).then((res) => {
        this.$vs.loading.close();
        this.$message.success('已同步');
        this.searchHandle();
      }).catch((err) => {
        this.$vs.loading.close();
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.project-user-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
